import React from "react";
import InputText from "../orders/accepted_orders/InputFilter";
import Container from "../Layout/Container";
import ContentBlock from "../Layout/ContentBlock";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import TableColumnUsers from "./items/TableColumnUsers";
import UserseditModal from "./items/UserseditModal";
import ContentValidation from "../common/ContentValidation";
import { SelectForm } from "../common/Buttons";
import Axios from "axios";
import {
  getUsers,
  postUser,
  deleteUer,
  updateUser,
} from "../../redux/Actions/userAction";
import { logoutUser } from "../../redux/Actions/authAction";
import { setOrderShopsOptions } from "../../redux/Actions/options_action";
import { connect } from "react-redux";
import PaginationComp from "../Dashboard/items/Pagination";
import ModalSimple from "../Layout/Modals/ModalSimple";

class Users extends React.Component {
  constructor() {
    super();
    this.state = {
      requiredId: 0,
      page: 1,
      pageCount: 100,
      paramsFilter: "",
      filter: {
        email: "",
        first_lastname: "",
        roles: [],
      },
      roleOptions: [],
      openModalEdit: true,
      data: {},
      action: "hide",
    };
  }

  componentDidMount() {
    this.reloadData(this.state.paramsFilter);
    this.props.setOrderShopsOptions('all');
    this.fetchRoles();
  }

  fetchRoles = () => {
    Axios.get("/api/v1/user_roles")
      .then((res) => {
        const roles = (res.data || []).map((role) => ({
          label: role.title,
          value: role.id,
        }));
        this.setState({ roleOptions: roles });
      })
      .catch(() => { });
  };

  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.reloadData(this.state.paramsFilter);
    }
    if (
      this.props.location.props2 &&
      this.state.openModalEdit &&
      this.props.totals !== 0
    ) {
      this.setState({
        openModalEdit: false,
      });
      document.getElementById(this.props.location.props2).click();
    }
  }

  reloadData = (paramsFilter) => {
    this.props.getUsers(this.state.page, this.state.pageCount, paramsFilter);
  };

  onAction = (action, data) => {
    this.setState({
      data,
      action,
    });
  };

  delayOnFilter = () => {
    if (this.props.loading_users) {
      return setTimeout(() => {
        return this.delayOnFilter();
      }, 1000);
    }
    this.onFilter();
  };

  onFilter = () => {
    if (this.props.loading_users) {
      return this.delayOnFilter();
    }
    let filterParams = [];
    if (this.state.filter.email.length > 0)
      filterParams.push(`&q[email_i_cont_any]=${this.state.filter.email}`);
    if (this.state.filter.first_lastname.length > 0) {
      let clientArray = this.state.filter.first_lastname.split(" ");
      clientArray.forEach((item) => {
        filterParams.push(`&q[firstname_or_lastname_cont]=${item}`);
      });
    }
    if (this.state.filter.roles.length > 0) {
      this.state.filter.roles.forEach((roleId) => {
        filterParams.push(`&q[user_role_id_in][]=${roleId}`);
      });
    }
    this.setState(
      {
        paramsFilter: filterParams.join(""),
        page: 1,
      },
      () => this.reloadData(filterParams.join(""))
    );
  };

  filterChange = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value,
      },
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };
  handleKeyDown = (e) => {
    if (e.key == "Enter") {
      this.onFilter();
    }
  };

  clearFilter = () => {
    this.setState(
      {
        filter: {
          email: "",
          first_lastname: "",
          roles: [],
        },
      },
      () => this.onFilter()
    );
  };

  render() {
    let onlyAdmin = ["admin", "manager"].includes(this.props.auth.role);
    return (
      <>
        <Container
          location={{
            locationName: "Users",
            locationUrl: this.props.match.url,
          }}
        >
          <>
            <ContentBlock>
              <FilterMenu
                totals={this.props.totals}
                length={this.props.users.length}
                onChangeCountPage={this.setPageCount}
                countPage={this.state.pageCount}
                text2="Users"
              />
            </ContentBlock>
            <ContentBlock>
              <TableFilterBox
                filter={false}
                add={onlyAdmin ? this.onAction : false}
                onFilter={onlyAdmin ? this.onFilter : false}
                clearFilter={onlyAdmin ? () => this.clearFilter() : false}
              >
                {onlyAdmin && (
                  <>
                    <div className="px-1">
                      <InputText
                        width={"0.75rem"}
                        number="1"
                        name="email"
                        placeholder="Email"
                        onKeyDown={this.handleKeyDown}
                        value={this.state.filter.email}
                        onChange={(e) => this.filterChange(e)}
                      />
                    </div>
                    <div className="px-1">
                      <InputText
                        width={"0.75rem"}
                        number="1"
                        name="first_lastname"
                        placeholder="Firstname Lastname"
                        onKeyDown={this.handleKeyDown}
                        value={this.state.filter.first_lastname}
                        onChange={(e) => this.filterChange(e)}
                      />
                    </div>
                    <div className="px-1" style={{ width: 200 }}>
                      <SelectForm
                        mode="multiple"
                        placeholder="Role"
                        onlyPlaceholder="Choose"
                        options={this.state.roleOptions}
                        value={this.state.filter.roles}
                        onChange={(roles) =>
                          this.setState(
                            {
                              filter: {
                                ...this.state.filter,
                                roles,
                              },
                            },
                            () => this.onFilter()
                          )
                        }
                      />
                    </div>
                  </>
                )}
              </TableFilterBox>
              <div>
                <ContentValidation
                  loader={this.props.loading_users}
                  array={this.props.users}
                  alertId_s="userAlert-s"
                  alertId_e="userAlert-e"
                >
                  <div className="table-responsive">
                    <table className="table table-sm table-hover mt-3">
                      <thead>
                        <tr className="text-muted">
                          <th className="text-black"></th>
                          <th className="text-black">E.mail</th>
                          <th className="text-black">Firstname</th>
                          <th className="text-black">Lastname</th>
                          <th className="text-black">Role</th>
                          <th className="text-black">Deactivation date</th>
                          <th className="text-black">Shops</th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.users.map((item, index) => {
                          return (
                            <TableColumnUsers
                              key={index}
                              index={index}
                              id={item.id}
                              item={item}
                              auth={this.props.auth}
                              onEdit={this.onAction}
                              onDelete={this.props.deleteUer}
                            />
                          );
                        })}
                      </tbody>
                    </table>
                    <PaginationComp
                      setPagination={this.setPagination}
                      page={this.state.page}
                      totals={this.props.totals}
                      pageCount={this.state.pageCount}
                    />
                  </div>
                </ContentValidation>
              </div>
            </ContentBlock>
          </>
          {this.state.action !== "hide" && (
            <ModalSimple
              text={this.state.action === "new" ? "Create new" : "Edit"}
              onClose={() => this.onAction("hide")}
              hide={true}
            >
              <UserseditModal
                action={this.state.action}
                data={this.state.data}
                auth={this.props.auth}
                postUser={this.props.postUser}
                updateUser={this.props.updateUser}
                logoutUser={this.props.logoutUser}
                onClose={() => this.onAction("hide")}
              />
            </ModalSimple>
          )}
        </Container>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth.user,
  users: state.user.users,
  totals: state.user.totals,
  loading_users: state.user.loading_users,
});

export default connect(mapStateToProps, {
  getUsers,
  postUser,
  deleteUer,
  updateUser,
  logoutUser,
  setOrderShopsOptions
})(Users);
